define('directives/common/ngSquareImage',[
	"application",
	"jquery"
], function (app, $) {

	return app.directives.directive("ngSquareImage", function () {

		return {
			restrict: "A",
			link: function ($scope, $element, attrs) {
				var element = $($element);

				$(window).resize(function () {
					element.height(element.width() * 0.7);
					//element.find("img").css("max-height",element.height()*0.7);
				});
			}
		};

	});

});
